import { NodeTypes } from '../../enums/node-types';
import { Node } from '../../models/base';

export class LayoutUtils {
  static nonElementNodes = [
    NodeTypes.SECTION,
    NodeTypes.ROW,
    NodeTypes.COLUMN,
    NodeTypes.NESTED_COLUMN,
    NodeTypes.GLOBAL_SECTION,
    NodeTypes.DYNAMIC_DATA_CONTENT
  ];

  static containerNodeTypes = [
    NodeTypes.ROW,
    NodeTypes.NESTED_ROW,
    NodeTypes.COLUMN,
    NodeTypes.NESTED_COLUMN,
    NodeTypes.SECTION,
    NodeTypes.GLOBAL_SECTION
  ];

  static fullHeightNodes = [NodeTypes.COLUMN, NodeTypes.NESTED_COLUMN];

  static fullWidthNodes = [
    NodeTypes.BLOG_HEADER,
    NodeTypes.BLOG_OVERVIEW,
    NodeTypes.CALL_OFF_ORDER_DETAILS,
    NodeTypes.MARKET_ITEM_LIST,
    NodeTypes.ORDER_DETAILS,
    NodeTypes.ORDER_OVERVIEW,
    NodeTypes.INVOICES,
    NodeTypes.PRODUCT_LISTER_BLOCK,
    NodeTypes.PRODUCT_PORTFOLIO,
    NodeTypes.QUICK_TDS_LINK,
    NodeTypes.TECHNOLOGY_ITEM_LIST,
    NodeTypes.TEXT_ACCORDION,
    NodeTypes.BRAND_LIST,
    NodeTypes.VAT_NUMBER_LIST,
    NodeTypes.CASE_STUDY_LIST,
    NodeTypes.FORM_EMBED,
    NodeTypes.IMAGE_GALLERY,
    NodeTypes.MARKET_LIST,
    NodeTypes.MARKET_SEGMENT_LIST,
    NodeTypes.MARKET_TILE_LIST,
    NodeTypes.PRODUCER_LIST,
    NodeTypes.PRODUCT_LIST,
    NodeTypes.RELATED_DOCUMENTS,
    NodeTypes.SHIPMENT_DETAILS,
    NodeTypes.TECHNOLOGY_TILE_LIST,
    NodeTypes.TILE,
    NodeTypes.DETAIL_HEADER,
    NodeTypes.DIVIDER,
    NodeTypes.EMAIL_UNSUBSCRIBE,
    NodeTypes.EXTENDED_TECHNICAL_PROPERTIES,
    NodeTypes.HOMEPAGE_SEARCH,
    NodeTypes.PRODUCT_TABLE,
    NodeTypes.REQUEST_FOR_QUOTATION,
    NodeTypes.REGISTRATION_NUMBER,
    NodeTypes.ADDRESS_LIST,
    NodeTypes.SHOPPING_CART,
    NodeTypes.NESTED_ROW
  ];

  static priorityElements = [NodeTypes.HOMEPAGE_SEARCH, NodeTypes.QUICK_TDS_LINK, NodeTypes.TILE];

  static isContainerNode(node: Node): boolean {
    return [NodeTypes.SECTION, NodeTypes.ROW, NodeTypes.COLUMN, NodeTypes.NESTED_ROW, NodeTypes.NESTED_COLUMN].includes(node.type);
  }

  static isColumnNode(node: Node): boolean {
    return node.type === NodeTypes.COLUMN || node.type === NodeTypes.NESTED_COLUMN;
  }

  static isRowNode(node: Node): boolean {
    return node.type === NodeTypes.ROW || node.type === NodeTypes.NESTED_ROW;
  }
}
